
import { Component, Vue } from 'vue-property-decorator'
import Navbar from '@/components/Navbar.vue'
import SpinLoader from '@/common/SpinLoader.vue'
import { namespace } from 'vuex-class'

const ui = namespace('UiModule')

/**
 * Main app component
 * Entry point of the application
 */
@Component({
  components: {
    Navbar,
    SpinLoader,
  },
})
export default class App extends Vue {
  get hideNavbar() {
    return this.$route.meta?.noNavbar
  }

  @ui.State
  globalLoading!: boolean
}
